"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnv = getEnv;
exports.getSSOSourceList = getSSOSourceList;
exports.setLoginSource = setLoginSource;
exports.getLoginSource = getLoginSource;
exports.removeLoginSource = removeLoginSource;
exports.removeToken = removeToken;
exports.redirectSSO = redirectSSO;
exports.redirectPortal = redirectPortal;
exports.commonLogic = commonLogic;
exports.fromSSOLogic = fromSSOLogic;
exports.getAccessToken = getAccessToken;

var _sso = _interopRequireDefault(require("./sso.config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function getEnv() {
  var _process$env$VUE_APP_;

  return (_process$env$VUE_APP_ = process.env.VUE_APP_ENV) === null || _process$env$VUE_APP_ === void 0 ? void 0 : _process$env$VUE_APP_.toLocaleLowerCase();
}

function getSSOSourceList() {
  return Object.keys(_sso.default[getEnv()]);
}

function setLoginSource() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 604800000;
  removeLoginSource();
  var expireTime = new Date().getTime() + time;
  localStorage.setItem('sso', JSON.stringify({
    source: source,
    expireTime: expireTime
  }));
}

function getLoginSource() {
  var ssoString = localStorage.getItem('sso');

  if (ssoString) {
    var _JSON$parse = JSON.parse(ssoString),
        source = _JSON$parse.source,
        expireTime = _JSON$parse.expireTime;

    var now = new Date().getTime();

    if (expireTime >= now) {
      return source;
    } else {
      removeLoginSource();
      return null;
    }
  }

  return null;
}

function removeLoginSource() {
  localStorage.removeItem('sso');
  sessionStorage.removeItem('sso');
}

function removeToken() {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
}

function redirectSSO() {
  var source = getLoginSource();

  if (getSSOSourceList().includes(source)) {
    window.location.href = _sso.default[getEnv()][source].protal_url + "/api/oauth/authorize?response_type=token&client_id=".concat(_sso.default[getEnv()][source].clientId, "&scope=all&redirect_uri=").concat(window.location.href.split('?')[0]);
  } else {
    console.error('sso来源错误');
  }
}

function redirectPortal() {
  var source = getLoginSource();

  if (getSSOSourceList().includes(source)) {
    removeLoginSource();
    removeToken();
    window.location.href = _sso.default[getEnv()][source].protal_url + "/index";
  } else {
    console.error('sso来源错误');
  }
}

function commonLogic(to, from, next, token, callback) {
  // const source: any = getLoginSource();
  if (token || to.name === 'login') {
    if (typeof callback === 'function') {
      callback();
    } else {
      next();
    }
  } else {
    next({
      name: 'login'
    });
  }
}

function fromSSOLogic(to, from, next, ssoSource, token, callback) {
  setLoginSource(ssoSource);
  redirectSSO(); // if (token) {
  //   if (typeof callback === "function") {
  //     callback();
  //   } else {
  //     next();
  //   }
  // } else {
  //   // 跳转SSO登录
  //   redirectSSO();
  // }
}

function getAccessToken(hash) {
  var arr = hash.split('&');
  var token = '';

  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (/^access_token/.test(item)) {
        token = item.split('=')[1];
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return token;
}